import axios from 'axios';
import storage from 'redux-persist/es/storage';

import {
  FETCH_DOWNLOAD_PACKING_LIST_FAILURE,
  FETCH_DOWNLOAD_PACKING_LIST_REQUEST,
  FETCH_DOWNLOAD_PACKING_LIST_RESET,
  FETCH_DOWNLOAD_PACKING_LIST_SUCCESS,
} from '../constants';

export const downloadPackingList = (data: any) => {
  return async function (dispatch: Function): Promise<void> {
    dispatch(fetchDownloadPackagingListRequest());
    const baseUrl = `${process.env.REACT_APP_API_URL}/apifabric/quote/packaging-list/`;
    const token = await storage.getItem('Token');

    axios
      .get(baseUrl, {
        params: {
          quoteId: data?.quoteId,
          fabricId: data?.fabricId,
          orderId: data?.orderId,
          isSupplierBaleAllocated: data?.isSupplierBaleAllocated,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const PIUrl = response?.data?.data?.response?.fileUrl || '';
        window.open(PIUrl);
        dispatch(fetchDownloadPackingListSuccess(response?.data?.data));
      })
      .catch((error) => {
        dispatch(fetchDownloadPackingListFailure(error.response));
      });
  };
};
export const fetchDownloadPackagingListRequest = (): Object => {
  return {
    type: FETCH_DOWNLOAD_PACKING_LIST_REQUEST,
  };
};
export const fetchDownloadPackingListSuccess = (downloadPackingList: any): Object => {
  return {
    type: FETCH_DOWNLOAD_PACKING_LIST_SUCCESS,
    payload: {
      data: downloadPackingList,
    },
  };
};
export const fetchDownloadPackingListFailure = (error: any): Object => {
  return {
    type: FETCH_DOWNLOAD_PACKING_LIST_FAILURE,
    payload: {
      error: error,
    },
  };
};

export const fetchDownloadPackingListReset = (): Object => {
  return {
    type: FETCH_DOWNLOAD_PACKING_LIST_RESET,
  };
};
